import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { NameContainer } from '../../Commons/Name'
import { AgeContainer } from '../../Commons/Age'

class Identity extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
    }

    render()
    {
        const { t } = this.props

        return (
            <div>
                { t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_civil_registry.steps.identity.title') }
                <NameContainer hasFocus={true} />
                <AgeContainer />
            </div>
        )
    }
}

export default withTranslation()(Identity)
